"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKBreadcrumb = void 0;
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var common_1 = require("../../common");
/**
 * Indicate the current page’s location within a navigational hierarchy that automatically adds separators via CSS
 *
 * @remarks
 * This is a simple wrapper of Reactstrap's Badge component, see
 * https://reactstrap.github.io/components/breadcrumbs/
 */
var GKBreadcrumb = function (props) { return (React.createElement(reactstrap_1.Breadcrumb, __assign({}, (0, common_1.mapDefaultProps)(props, { _gkComponentName: "gk-breadcrumb" })))); };
exports.GKBreadcrumb = GKBreadcrumb;
